import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { ServiceCard } from "@/components/ServiceCard";
import { ConsultButton } from "@/components/CtaButtons";
import { TurnkeySection } from "@/sections/HomeTrust";
import { FinalCta } from "@/sections/HomeVoice";
import { useLanguage } from "@/i18n/LanguageContext";
import { SERVICES } from "@/data/content";
import { IMAGES } from "@/data/images";

export default function Services() {
  const { t } = useLanguage();
  return (
    <>
      <PageHero eyebrow={t("services.eyebrow")} title={t("services.title")} sub={t("services.sub")} image={IMAGES.plan2} />
      <section className="bg-charcoal py-24 md:py-32" data-testid="services-list">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {SERVICES.map((s, i) => (
              <Reveal key={s.id} delay={(i % 3) * 0.08}>
                <ServiceCard service={s} detailed />
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-14 text-center">
            <ConsultButton testid="services-consult-button" />
          </Reveal>
        </div>
      </section>
      <TurnkeySection />
      <FinalCta />
    </>
  );
}
